// extracted by mini-css-extract-plugin
export default {"SpreadsheetViewer":"qVF0x","inViewer":"YpVts","frame":"rqJKx","disablePointEvents":"gcKU9"};